import React from 'react';
import { useSelector } from 'react-redux';
import { getBuildedMatfileTemplate } from "@/helpers/matfile";

const getFillColor = (colorSchema) => {
  const matfileTemplate = getBuildedMatfileTemplate();
  const colorMode = matfileTemplate?.color_mode;
  switch (colorMode) {
    case 'ArticleColor': {
      if (colorSchema) {
        return colorSchema.background_color_hex;
      }
    }
    case 'Transparent': {
      return 'transparent';
    }
    default: {
      return 'none';
    }
  };
}

const MaterialOutline = props => {
  const { x, y, width, height, pageRectStrokeStyle } = props;
  const selWizard = useSelector(state => state.core.selWizard);
  const colorSchema = useSelector(state => state.core.colorSchema);
  const fill = getFillColor(colorSchema);
  if (selWizard) {
    return null;
  }
  return <rect id="material-outline" x={x} y={y} width={width} height={height} fill={fill} {...pageRectStrokeStyle} />;
};

export default MaterialOutline;
